<template>
	<div>
		<div class="head">
			<img src="@/assets/headImg/head.jpg" style="width: 100%;
		vertical-align:top;" class="lunbo1" />

			<div>
				<pcBack></pcBack>
			</div>
			<div class="img_box">

				<p class="MsoNormal">
					<span style="font-size:18px;"><strong>中华医学会第一次细菌真菌感染学术会议</strong></span>
				</p>
				<p class="MsoNormal">
					<span style="font-size:18px;"><strong>会议注册须知：</strong></span>
				</p>
				<p class="MsoNormal">
					<span style="font-size:16px;">会议代表可以通过</span><b><span style="font-size:16px;">线上、线下</span></b><span style="font-size:16px;">两种方式参加本次会议。</span>
				</p>
				<p class="MsoNormal">
					<span style="font-size:16px;">&nbsp;</span>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<b><span style="font-size:16px;">一、线下参会：</span></b>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<span style="font-size:16px;">根据大会疫情防控需求，本次会议</span><b><span style="font-size:16px;">线下参会人数限</span><span style="font-size:16px;">1000人</span></b><span
					 style="font-size:16px;">。</span>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<span style="font-size:16px;">&nbsp;</span>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<span style="font-size:16px;">线下参会人员：包括中华医学会细菌感染与耐药防治分会全国委员、青委、专题报告人、主持人、其他受邀专家及组委会审核批准的注册人员。</span>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<span style="font-size:16px;">&nbsp;</span>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<b><span style="font-size:16px;">线下参会注册截止日期：</span></b>
					<b><span style="font-size:16px;">4</span></b>
					<b>
						<span style="font-size:16px;">月</span>
						<span style="font-size:16px;">7</span>
					</b>
					<b><span style="font-size:16px;">日</span></b>

				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<b> <span style="font-size:16px;">注册费：</span></b>
				</p>
				<table class="MsoTableGrid" border="1" cellspacing="0" style="border:none;">
					<tbody>
						<tr>
							<td width="276" valign="top" style="border:1.0000pt solid windowtext;">
								<p class="MsoNormal">
									<span style="font-family:宋体;font-size:16px;margin-left: 20px;">提前注册</span><span style="font-family:宋体;font-size:10.5pt;"></span>
								</p>
							</td>
							<td width="276" valign="top" style="border:1.0000pt solid windowtext;">
								<p class="MsoNormal">
									<span style="font-family:宋体;font-size:16px;margin-left: 20px;">200元/人</span><span style="font-family:宋体;font-size:10.5pt;"></span>
								</p>
							</td>
						</tr>
						<tr>
							<td width="276" valign="top" style="border:1.0000pt solid windowtext;">
								<p class="MsoNormal">
									<span style="font-family:宋体;font-size:16px;margin-left: 20px;">现场注册</span><span style="font-family:宋体;font-size:10.5pt;"></span>
								</p>
							</td>
							<td width="276" valign="top" style="border:1.0000pt solid windowtext;">
								<p class="MsoNormal">
									<span style="font-family:宋体;font-size:16px;margin-left: 20px;">3</span><span style="font-family:宋体;font-size:16px;">00</span><span
									 style="font-family:宋体;font-size:16px;">元/人</span><span style="font-family:宋体;font-size:10.5pt;"></span>
								</p>
							</td>
						</tr>
					</tbody>
				</table>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<span style="font-size:16px;">本次会议现场将由</span><span style="font-size:16px;">“中华医学会”收取注册费并开具注册费发票。</span>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<span style="font-size:16px;">&nbsp;</span>
				</p>
				<p class="16" style="margin-left:21.0000pt;text-indent:-21.0000pt;background:#FFFFFF;">
					<span style="font-size:16px;"><span style="font-size:32px;"><strong>.&nbsp;</strong></span>代表个人注册请登录会议网站</span><a
					 href="http://bisc2021.ganzhiyu.com"><u><span style="font-size:16px;">http://bisc2021.ganzhiyu.com</span></u></a><span
					 style="font-size:16px;">点击：“个人参会注册”按钮，在线填写注册信息。</span>
				</p>
				<p class="16" style="margin-left:21.0000pt;text-indent:-21.0000pt;background:#FFFFFF;">
					<span style="font-size:16px;"><span style="font-size:32px;"><strong>.</strong></span>&nbsp;&nbsp;</span><span
					 style="font-size:16px;"> 团队参会（</span><span style="font-size:16px;">10</span><span style="font-size:16px;">人以上）请进入会议团队注册模块，并将</span><span
					 style="font-size:16px;">“团队注册表”上传至后台，会务组将对注册信息进行审核。</span>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<span style="font-size:16px;">&nbsp;</span>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<b><span style="font-size:16px;">参会要求：</span></b>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<b><span style="font-size:16px;">中高风险地区代表谢绝参加线下会议（包含</span><span style="font-size:16px;">15天内有中高风险地区旅居史）</span></b><span
					 style="font-size:16px;">，线下个人参会代表报到时请提前完成健康填报，现场请准备好</span><span style="font-size:16px;">“随申码”绿码，携带本人身份证原件，现场报到时须签署个人行程承诺书。</span>
				</p>
				<!-- <p class="MsoNormal" style="background:#FFFFFF;">
          <span style="font-size:16px;">无法参加线下会议的代表可以欢迎通过线上形式参加本次会议观看会议直播。</span>
        </p> -->
				<p class="MsoNormal" style="background:#FFFFFF;">
					<span style="font-size:16px;">&nbsp;</span>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<b><span style="font-size:16px;">二、线上参会：</span></b>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<span style="font-size:16px;">无法参加线下会议的代表可以通过线上形式参加本次会议。线上参会代表请登录会议网站</span><span style="font-size:16px;">“http://bisc2021.ganzhiyu.com”，在线填写注册信息进行网上注册，在线参会免收注册费。</span>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<span style="font-size:16px;">&nbsp;</span>
				</p>
				<p class="MsoNormal">
					<span style="font-size:16px;">&nbsp;</span>
				</p>
				<p class="MsoNormal">
					<span style="font-size:16px;">&nbsp;</span>
				</p>
				<p class="MsoNormal" style="background:#FFFFFF;">
					<b><span style="font-size:16px;">三、注册咨询</span></b>
				</p>
				<p class="MsoNormal">
					<b><span style="font-size:16px;">联系人：瞿韦平</span><span style="font-size:16px;">: </span></b><br />
					<b><span style="font-size:16px;">电</span> <span style="font-size:16px;">话：</span><span style="font-size:16px;">180-1600-8787</span></b><br />
					<b><span style="font-size:16px;">邮</span> <span style="font-size:16px;">箱：</span><span style="font-size:16px;">q</span></b><b><span
						 style="font-size:16px;">uwp@fumed.com.cn</span></b>
				</p>
				<p class="MsoNormal">
					&nbsp;
				</p>
				<p>
					<br />
				</p>
			</div>


			<!-- 选择登录的方式 -->
			<div class="flex btn_box">
				<div class="btn" @click="onLine" style="margin-left: 10px;">
					线上参会注册
				</div>
				<div class="btn" @click="godlu">
					线下个人参会
				</div>
				<div class="btn" @click="isteam">
					线下团队参会
				</div>
			</div>
			<div class="zhanghao" @click="sigin">
				<el-link type="primary" style="font-size: 16px;">已有账号，请登录</el-link>
			</div>
			<!-- 线下注册弹窗 -->
			<!-- <div class="tanchuang" v-show="isshow" @click="isshowbtn">
        <div class="btn_big">
          <div class="btn_xiao">
            <div class="btn btn11" style="margin-bottom: 30px;" @click="godlu">个人参会注册</div>
            <div class="btn btn11" @click="isteam">团队参会注册</div>
          </div>
        </div>
      </div> -->
			<logocom class="isshow2"></logocom>
		</div>

	</div>
</template>

<script>
	import logocom from '@/components/logo/logo.vue';
	import pcBack from '../../components/back/back.vue';

	export default {
		data() {
			return {
				isshow: false,
				isonline: '',
			}
		},
		components: {
			logocom,
			pcBack
		},
		methods: {

			retrun: function() {
				this.$router.push({
					path: '/'
				})
			},

			sigin: function() {
				this.isonline = '是'
				this.$router.push({
					path: "/signIn"
				})
			},
			onLine: function() {
				this.isonline = '是'
				this.$router.push({
					name: "register",
					query: {
						isonline: this.isonline,
						selete: 1
					}
				})
			},
			isteam() {
				// alert("线下参会注册已截止.....")
				this.$router.push({
					path: "/teamRegister",
				})
			},
			offline: function() {
				this.isonline = '否'
				this.isshow = true
			},
			isshowbtn: function() {
				this.isshow = false
			},
			godlu: function() {
				alert("线下参会注册已截止.....")
				// this.isonline = '否'
				// this.$router.push({
				// 	name: "register",
				// 	query: {
				// 		isonline: this.isonline,
				// 		selete: 2
				// 	}
				// })
			}
		}
	}
</script>

<style scoped lang="scss">
	@import '@/assets/style/style.scss';

	.head {
		width: 980px;
		margin: 0 auto;
	}

	.img_box {
		width: 900px;
		margin: 0 auto;


	}

	.btn {
		font-size: 14px;
		width: 200px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		margin-right: 20px;
		border-radius: 5px;
		border: 1px solid rgba(0, 0, 0, 0.2);
		cursor: pointer;
	}

	.btn_box {
		width: 450px;
		margin: 0 auto;

	}

	.tanchuang {
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.3);
		position: fixed;
		top: 0;
		left: 0;
	}

	.btn_big {
		width: 400px;
		height: 300px;
		background-color: #fff;
		border-radius: 3px;
		margin-left: 50%;
		transform: translateX(-50%);
		margin-top: 250px;
		overflow: hidden;
	}

	.btn_xiao {
		margin-top: 90px;
	}

	.btn11 {
		margin-left: 50%;
		transform: translateX(-50%);
	}

	.zhanghao {
		color: #777;
		width: 130px;
		margin: 0 auto;
		margin-bottom: 50px;
		margin-top: 15px;
		cursor: pointer;
	}

	.isshow2 {
		display: none;
	}

	@media (max-width: 500px) {
		.head {
			width: 100%;
			padding-right: 0;
		}

		.img_box {
			width: 90%;
		}

		.btn {
			width: 150px;
		}

		.btn_box {
			width: 330px;
		}

		.btn_big {
			width: 280px;
			height: 200px;
			margin-top: 200px;
		}

		.btn_xiao {
			margin-top: 45px;
		}

		.isshow2 {
			display: block;
		}

	}
</style>
